var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3332 4.21667H4.6665V29.5133H27.3332V4.21667Z",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 16.0267L15.9998 4.69336L27.3332 16.0267",
    stroke: "#1F2937",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30V28.2754C7 24.8143 9.43619 22 12.4322 22H19.5678C22.5638 22 25 24.8143 25 28.2754V30H7Z",
    fill: "#1F2937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 21.3333C13.4263 21.3333 11.333 19.24 11.333 16.6667C11.333 14.0933 13.4263 12 15.9997 12C18.573 12 20.6663 14.0933 20.6663 16.6667C20.6663 19.24 18.573 21.3333 15.9997 21.3333Z",
    fill: "#1F2937"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.48669C17.6569 7.48669 19 6.14355 19 4.48669C19 2.82984 17.6569 1.48669 16 1.48669C14.3431 1.48669 13 2.82984 13 4.48669C13 6.14355 14.3431 7.48669 16 7.48669Z",
    fill: "#1F2937",
    stroke: "#C9906A",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDp);
export default __webpack_public_path__ + "static/media/icon-dp.c45cafcfb74aac925d43eb1608925d01.svg";
export { ForwardRef as ReactComponent };